import { post } from "../base";
import { get } from "../base";

//获取课程评分订单列表
export async function courseList(params) {
    let respObj = await get("/organization-course/credit",params);
    return respObj;
}

//获取课程评分的名单列表
export async function namelist(params) {
    let respObj = await get("/organization-course/namelist",params);
    return respObj;
}

//课程评分名单批量审核
export async function statusBatch(params) {
    let respObj = await get("/organization-course/statusBatch",params);
    return respObj;
}

//课程中的感悟列表
export async function studyfeelinglist(params) {
    let respObj = await get("/organization-course/studyfeelinglist",params);
    return respObj;
}

//查看个人感悟
export async function getfeeling(params) {
    let respObj = await get("/bus/score/user-assess-info",params);
    return respObj;
}
//获取线下课程学习情况
export async function getOfflineSign(params) {
    let respObj = await get("/organization/siginin/user-signin-info",params);
    return respObj;
}
//批量打分
export async function gradeBatch(params){
    return await post('/organization-course/gradeBatch', params);
}
//单独打分
export async function grade(params){
    return await get('/organization-course/grade', params);
}
//获取课程里面的分类 
export async function classify(){
    return await get('/organization/course/classify');
}

//添加课程
export async function addCourse(params){
    return await post('/organization/course/add', params);
}
//修改课程
export async function editCourse(params){
    return await post('/organization/course/edit', params);
}
//创建课程-查询课程列表
export async function getCourseList(params){
    return await get('/organization/course/list',params)
}

//结算单列表  
export async function getJsd(params){
    return await get('/organization/settlement/list',params)
    
}
//结算单详情 
export async function jsdDetail(params){
    return await get('/organization/settlement/info',params)
    
} 
//考核要求
export async function khyq(params){
    return await get('/organization/course/getassessment/'+params)
} 
export async function getHandleLive(id){
    return await get('/edu-classroom/live/livescheduleurl/'+id)
} 
//已上线课程-查询课程列表
export async function onlinelist(params){
    return await get('/organization/course/onlinelist',params)
}

//已上线课程--查看个人感悟 
export async function kcGetfeeling(params){
    return await get('/organization-course/getfeeling',params)
}

//停止报名
export async function stopApply(params){
    return await get('/organization/course/apply',params)
}
//取消课程
export async function cancelCourse(params){
    return await get('/organization/course/cancel',params)
}
//结算单提交审核
export async function jsdSh(params){
    return await get('/organization/settlement/put',params)
}
//创建课程---提交审核  
export async function toexamizate(params){
    return await post('/organization/course/toexamizate', params);
}
//查看课程详情
export async function courseDetail(params){
    return await get('/organization/course/'+params)
}

//视频预览获取签名
export function getSignVideoUrl(id){
    return get('/api/oss/getSignVideoUrl/' + id)
}
//获取课程类型全部课程、线下课程、线上课程
export async function getCourseTypeList(){
    return await get('/organization/course/course-type')
}
// 查询课程海报
export async function getCoursePoster(id) {
    return await get('/edu-classroom/course/course-poster/' + id + "?reload=0")
}